import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import menuReducer from "../features/menu/menuSlice";
import driverReducer from "../features/driver/driverSlice";
import driverReviewsReducer from "../features/driverReviews/driverReviewsSlice";
import organizationReducer from "../features/organization/organizationSlice";
import patientReducer from "../features/patient/patientSlice";
import ordersReducer from "../features/orders/ordersSlice";
import settingsReducer from "../features/settings/settingsSlice";
import reportReducer from "../features/report/reportSlice";
import categoryReducer from "../features/category/categorySlice";
import meReducer from "../features/me/meSlice";
import brandsReducer from "../features/brands/brandsSlice";
import strainsReducer from "../features/strains/strainsSlice";
import rolesReducer from "../features/roles/rolesSlice";
import registerReducer from "../features/register/registerSlice";
import integrationSettingReducer from "../features/integrationSetting/integrationSettingSlice";
import alpineiqReducer from "../features/alpineiq/alpineiqSlice";
import driversBagsReducer from "../features/driverBags/driverBagsSlice";
import bagItemsReducer from "../features/driverBags/bagItems/bagItemsSlice";
import cashHandoversReducer from "../features/cashHandovers/cashHandoversSlice";
import teamMembersReducer from "../features/teamMembers/teamMembersSlice";
import forgetPasswordReducer from "../features/forgetPassword/forgetPasswordSlice";
import topSoldProductReducer from "../features/report/topSoldProducts/topSoldProductsSlice";
import topSoldBrandReducer from "../features/report/topSoldBrands/topSoldBrandsSlice";
import topSoldCategoryReducer from "../features/report/topSoldCategories/topSoldCategoriesSlice";
import reportTaxesReducer from "../features/report/reportTaxes/reportTaxesSlice";
import firstTimeCustomersReducer from "../features/report/firstTimeCustomers/firstTimeCustomersSlice";
import reactivatedCustomersReducer from "../features/report/reactivatedCustomers/reactivatedCustomersSlice";
import driverRegionSalesReducer from "../features/report/driverRegionSales/driverRegionSalesSlice";
import changePassWordReducer from "../features/changePassword/changePasswordSlice";
import genericReportsReducer from "../features/report/genericReports/genericReportsSlice";
import dailyOrdersReducer from "../features/report/dailyOrders/dailyOrdersSlice";
import paymentMethodsReducer from "../features/report/paymentMethods/paymentMethodsSlice";
import topRegionsReducer from "../features/report/topRegions/topRegionsSlice";
import topRegionsV3Reducer from "../features/report/topRegionsV3/topRegionsV3Slice";
import topSoldProductsV3Reducer from "../features/report/topSoldProductsV3/topSoldProductsV3Slice";
import dailyOrdersV3Reducer from "../features/report/dailyOrdersV3/dailyOrdersV3Slice";
import paymentMethodsV3Reducer from "../features/report/paymentMethodsV3/paymentMethodsV3Slice";
import paymentTypesReducer from "../features/orders/paymentTypes/paymentTypesSlice";
import groupsReducer from "../features/groups/groupsSlice";
import discountsReducer from "../features/discounts/discountsSlice";
import locationsReducer from "../features/location/locationSlice";
import generatedReportsReducer from "../features/generatedReports/generatedReportsSlice";
import comparePanelReducer from "../features/comparePanel/comparePanelSlice";
import metricReducer from "../features/metrics/metricSlice";
import blogsReducer from "../features/blogs/blogSlice";
import metrcSalesReducer from "../features/metrics/MetrcSales/metrcSalesSlice";
import metrcItemsReducer from "../features/metrics/MetrcItems/metrcItemsSlice";
import metrcStrainsReducer from "../features/metrics/MetrcStrains/metrcStrainsSlice";
import metrcTransactionsReducer from "../features/metrics/MetrcTransactions/metrcTransactionsSlice";
import metrcTransfersReducer from "../features/metrics/MetrcTransfers/metrcTransfersSlice";
import metrcRetaildeliveriesReducer from "../features/metrics/MetrcRetailDeliveries/metrcRetaildeliveriesSlice";
import safeReducer from "../features/safe/safeSlice";
import promoCodesReducer from "../features/promoCodes/promoCodesSlice";
import shopSettingsReducer from "../features/shopSettings/shopSettingsSlice";
import salarySettingsReducer from "../features/salarySettings/salarySettingsSlice";
import taxsettingsReducer from "../features/taxSettings/taxSettingsSlice";
import canceledOrdersReducer from "../features/report/CanceledOrders/CanceledOrdersSlice";
import aiChatReducer from "../features/aiChat/AIChatSlice";
import inventoryReducer from "../features/inventory/inventorySlice";
import handoffReducer from "../features/handoff/handoffSlice";
import notificationsReducer from "../features/notifications/notificationsSlice";
import loggedInUsersReducer from "../features/loggedInUsers/loggedInUsersSlice";
import payrollReducer from "../features/payroll/payrollSlice";
import themeReducer from "../features/theme/themeSlice";
import aiAccessReducer from "../features/aiAccess/aiAccessSlice";
import orderMessagesReducer from "../features/orderMessages/orderMessagesSlice";
import orderSourcesReducer from "../features/orderSources/orderSourcesSlice";

export const store = configureStore({
  reducer: {
    blogs: blogsReducer,
    auth: authReducer,
    menu: menuReducer,
    safe: safeReducer,
    driver: driverReducer,
    driverReviews: driverReviewsReducer,
    driversBags: driversBagsReducer,
    bagItems: bagItemsReducer,
    cashHandovers: cashHandoversReducer,
    organization: organizationReducer,
    patient: patientReducer,
    orders: ordersReducer,
    orderMessages: orderMessagesReducer,
    orderSources: orderSourcesReducer,
    settings: settingsReducer,
    cardReports: reportReducer,
    categorys: categoryReducer,
    me: meReducer,
    brands: brandsReducer,
    strains: strainsReducer,
    roles: rolesReducer,
    register: registerReducer,
    integrationSetting: integrationSettingReducer,
    alpineiq: alpineiqReducer,
    teamMembers: teamMembersReducer,
    forgetPassWord: forgetPasswordReducer,
    topSoldProducts: topSoldProductReducer,
    topSoldBrands: topSoldBrandReducer,
    topSoldCategories: topSoldCategoryReducer,
    reportTaxes: reportTaxesReducer,
    firstTimeCustomers: firstTimeCustomersReducer,
    reactivatedCustomers: reactivatedCustomersReducer,
    driverRegionSales: driverRegionSalesReducer,
    changePassWord: changePassWordReducer,
    genericReports: genericReportsReducer,
    dailyOrders: dailyOrdersReducer,
    paymentMethods: paymentMethodsReducer,
    topRegions: topRegionsReducer,
    topRegionsV3: topRegionsV3Reducer,
    topSoldProductsV3: topSoldProductsV3Reducer,
    dailyOrdersV3: dailyOrdersV3Reducer,
    paymentMethodsV3: paymentMethodsV3Reducer,
    paymentTypes: paymentTypesReducer,
    groups: groupsReducer,
    discounts: discountsReducer,
    locations: locationsReducer,
    generatedReports: generatedReportsReducer,
    comparePanel: comparePanelReducer,
    promoCodes: promoCodesReducer,
    metrics: metricReducer,
    metrcSales: metrcSalesReducer,
    metrcItems: metrcItemsReducer,
    metrcStrains: metrcStrainsReducer,
    metrcTransactions: metrcTransactionsReducer,
    metricTransfers: metrcTransfersReducer,
    metrcRetailDeliveries: metrcRetaildeliveriesReducer,
    shop_settings: shopSettingsReducer,
    salary_settings: salarySettingsReducer,
    taxSettings: taxsettingsReducer,
    canceledOrders: canceledOrdersReducer,
    aiChats: aiChatReducer,
    inventory: inventoryReducer,
    handoff: handoffReducer,
    notifications: notificationsReducer,
    loggedInUsers: loggedInUsersReducer,
    payroll: payrollReducer,
    theme: themeReducer,
    aiAccess: aiAccessReducer,
  },
});
